module.exports = __webpack_public_path__ + "static/assets/513f341ec4f20bd8578ced7d21b79113.svg";